<template>
    <div class="lang">
        <div class="info">
            <h3 class="bullet01">Яаралтай тусламж авах</h3>
            <p class="depth bullet03">Яаралтай(амаржих) өвчтөн 24 цагийн алинд ч тусламж үйлчилгээ авах боломжтой.</p>
            <p class="depth bullet03">Манай төв яаралтай тусламж хэрэгтэй өвчтөнүүдэд 24 цагийн алинд нь тусламж үйлчилгээ үзүүлэхийн тулд яаралтай тусламжийн эмчилгээний тоног төхөөрөмж, өрөө тасаг, яаралтай тусламжийн нарийн мэргэжлийн эмч мэргэжилтнүүдийг бэлэн байдалд байлгаж, түргэн шуурхай тусламж үйлчилгээ үзүүлэхийн төлөө бүх хүчээ дайчлан ажиллаж байна.</p>
            <p class="depth bullet03">Манай тасаг яаралтай тусламж шаардлагатай өвчтөнүүдэд эрүүл мэндийн байгууллагын өвчтөн шилжүүлэх систем(1, 2-р шатлалын эмнэлгээр дамжин ирэх шаардлагагүй) болон оршин суугаа газрын харьяаллаас үл хамааран шууд тусламж үзүүлнэ.</p>
            <p class="depth bullet03">Яаралтай тусламжийн төвд утасгүй холбооны сүлжээ, яаралтай тусламжийн багаж хэрэгсэл, түргэний тэрэг 24 цагийн турш бэлэн байдалд байдаг бөгөөд яаралтай тусламжийн сүлжээг бий болгон шөнийн болон амралтын өдрүүдэд ачааллыг тэнцүүлэн ажиллаж байна.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Яаралтай тусламжийн бүртгэл</h3>
            <p class="depth">Яаралтай тусламжийн тасагт ирсэн өвчтөн өвчний хүнд хөнгөнөөс хамаарч эрэмбэлэн ангилах өрөөнд урьдчилсан үзлэгт үзүүлсний дараа тасаг дотор байрлах бүртгэл.төлбөр төлөх цонхонд эмчлүүлэх хүсэлтийн хуудас, эрүүл мэндийн даатгалын дэвтэр(эрүүл мэндийн тэтгэмжийн дэвтэр), биеийн байцаалтаа өгнө үү.</p>
            <p class="depth">Санхүүгийн албанаас өвчтөний нэр бичсэн наадаг цаас, бугуйвчийг авч яаралтай тусламжийн тасгийн сувилагчид өгнө.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Яаралтай тусламж үйлчилгээ</h3>
            <p class="depth">Яаралтай тусламжийн эмч зохих эмчилгээг хийсний дараа гэртээ харих, эмнэлэгт хэвтэх эсэхийг шийднэ.</p>
        </div>
        <div class="info">
            <h3 class="bullet01">Төлбөр төлөх</h3>
            <p class="depth">
                Өвчтөний эмчилгээний төлбөрийг гэртээ харих шийдвэр гарсны дараа төлнө. Харин тусгай(MRI, CT, эхо) шинжилгээний төлбөрийг шинжилгээ хийлгэхээс өмнө төлнө. <br>
                Эрүүл мэндийн даатгалтай эсэх, эрүүл мэндийн тэтгэмж авдаг эсэх нь тогтоогдоогүй өвчтөн эмчилгээний төлбөрийг 100% өөрөө төлөх ёстой. <br>
                Эмчилгээний төлбөрийг зээлийн картаар төлж болно.
            </p>
        </div>
        <div class="info">
            <h3 class="bullet01">Гэртээ харих буюу эмнэлэгт хэвтэх</h3>
            <div class="table">
                <table>
                    <colgroup>
                        <col style="width: 50%;">
                        <col style="width: 50%;">
                    </colgroup>
                    <thead>
                        <tr>
                            <th>Гэртээ харих</th>
                            <th>Эмнэлэгт хэвтэх</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>
                                Гэртээ харих буюу эмнэлэгт хэвтэх (Гэртээ харих, Эмнэлэгт хэвтэх) <br>
                                Гэртээ харих	Эмнэлэгт хэвтэх <br>
                                Эмчилгээний төлбөрийн баримтыг сувилагчид өгч эмээ аваад эмчилгээний заавар болон гэртээ хариад анхаарах зүйлийн талаар тайлбарлуулсны дараа гэртээ харина уу.
                            </td>
                            <td>
                                Эмнэлэгт хэвтэх шийдвэр гарсан тохиолдолд хариуцсан сувилагчаас хэрхэн хэвтэх талаар зааварчилгаа авсны дараа яаралтай тусламжийн Санхүүгийн албаны бүртгэл·төлбөр төлөх цонхонд очиж бүртгүүлээд эмнэлэгтээ хэвтэнэ.
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>